import {useDataSource} from './dataSource';

export const useLocation = () => useDataSource('location');
